import React, { useRef } from "react";
import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
} from "@mui/material";

import { Close, Print } from "@mui/icons-material";
import CloseButton from "../../../components/commonComponents/Buttons/CloseButton";
import Review from "./WizardSteps/Review";
import { listStoreCapacities, loadLoopCampaignVisuals, setLoopCampaignInfo } from "../../../api_calls/loopCampaign";
import { useDispatch, useSelector } from "react-redux";
import { updateStateData } from "../../../Store/actions";
import { checkStatus, formatToStandardDate } from "../../../api_calls/utils";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import ActionButton from "../../../components/commonComponents/Buttons/ActionButton";
import ActiveInactiveVisualsList from "./WizardSteps/ActiveInactiveVisualsList";

const LoopReview = ({ open, loopInfo, size, closeModal }) => {
    const currentStateData = useSelector((state) => state.userSelections);
    const dispatchAction = useDispatch();

    const contentRef = useRef();

    const handleDownloadPdf = async () => {
        const element = contentRef.current;

        // Convert DOM to canvas with high resolution
        const canvas = await html2canvas(element, {
            useCORS: true,
            scale: 2  // Boosts resolution
        });

        const imgData = canvas.toDataURL('image/png');
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;

        // Create PDF with dimensions matching the canvas
        const pdf = new jsPDF({
            orientation: canvasWidth > canvasHeight ? 'landscape' : 'portrait',
            unit: 'px',
            format: [canvasWidth, canvasHeight]
        });

        // Add the image at 1:1 scale
        pdf.addImage(imgData, 'PNG', 0, 0, canvasWidth, canvasHeight);

        const pdfName = loopInfo.name
            ? loopInfo.name.replace(/\s+/g, '_') + ".pdf"
            : 'loop_campaign.pdf';

        pdf.save(pdfName);
    };




    React.useEffect(() => {
        loadLoopCampaignVisuals(loopInfo.id).then((response) => {
            setLoopCampaignInfo(loopInfo);
            listStoreCapacities(loopInfo.id);
        }
        )
    }, []);

    return (
        <Dialog
            open={open}
            onClose={(e) => {
                e.preventDefault();
            }}
            fullWidth={true}
            maxWidth={"xl"}
        >
            <DialogTitle>Review Loop-Based Campaign</DialogTitle>
            <DialogContent>
                {
                    typeof currentStateData.new_loop_data !== "undefined" && (
                        <div ref={contentRef}>
                            <Review usedFor={"listReview"} loopInfo={loopInfo} />
                        </div>
                    )
                }
                
            </DialogContent>
            <Box height={20} />
            <DialogActions>
                <Stack direction={"row"} spacing={2}>
                    <CloseButton
                        onClick={(e) => {
                            e.preventDefault();
                            closeModal();
                        }}
                        label="Close"
                        icon={<Close />}
                    />
                    {/* <ActionButton
                        label="Download PDF"
                        onClick={handleDownloadPdf}
                        icon={<Print />}
                        variant="contained"
                        color="primary"
                    /> */}
                </Stack>
            </DialogActions>
        </Dialog>
    );
};

export default LoopReview;
